import { OrderDetails } from 'types';
import { ExpensesType } from './OrderDetails.types';
import { i18nStore } from 'contexts/i18n';
import getConfig from 'next/config';
import { isAPACStore } from 'utils';

const formatDate = (dateString: Date | undefined) => {
  return dateString ? new Date(dateString).toISOString().split('T')[0] : null;
};

export const dateParser = (
  orderDetails: OrderDetails | undefined,
  i18n: i18nStore
) => {
  const { orderDate } = orderDetails || {};

  return [
    {
      name: i18n['Order Date'],
      value: () => formatDate(orderDate),
    },
  ];
};

export const expenseParser = (
  orderDetails: OrderDetails | undefined,
  i18n: i18nStore
) => {
  const { shippingCost, subTotal, tax, withholdingTax, orderSavings, redemptionPoints } =
    orderDetails ?? {};

  const hardcodedShippingMethodForUSA = 'UPS';

  const EXPENSES: ExpensesType = [
    {
      name: i18n['Subtotal'],
      value: subTotal,
    },
  ];

  if (!isAPACStore()) {
    EXPENSES.push({
      name: i18n['Shipping method'],
      value: hardcodedShippingMethodForUSA,
    });
  }

  EXPENSES.push({
    name: i18n['Shipping cost'],
    value: shippingCost,
  });

  EXPENSES.push({
    name: i18n['Tax'],
    value: tax,
  });

  const withholdingTaxNum = convertCurrencyToNumber(withholdingTax ?? '');
  if (!isNaN(withholdingTaxNum) && withholdingTaxNum !== 0) {
    EXPENSES.push({
      name: i18n['Withholding Tax'],
      value: withholdingTax,
    });
  }

  if (redemptionPoints && parseInt(redemptionPoints) > 0) {
    EXPENSES.push({
      name: i18n['Redemption Points'],
      value: redemptionPoints,
    });
  }

  if (convertCurrencyToNumber(orderSavings) !== 0) {
    EXPENSES.push({
      name: i18n['Discount'],
      value: orderSavings,
      isDiscountType: true,
    });
  }

  return EXPENSES;
};

export const isDiscount = (discountValue: string | undefined) =>
  discountValue?.includes('-');

// sometimes currency can be "$0.00" which is valid string, hence the regex check
/* regular expression /[^0-9.-]/g is used to match and remove any characters that are not digits (0-9), hyphens (-),
   or periods (.) from the 'currency' string. */
export const convertCurrencyToNumber = (currency = '') =>
  parseFloat(currency.replace(/[^0-9.-]/g, ''));

export const orderDetailsMarkup = (i18n: i18nStore) => ({
  productName: i18n['Item'],
  quantity: i18n['Qty.'],
  price: i18n['Unit Price'],
  total: i18n['Total'],
  points: i18n['Points'],
  status: i18n['Status'],
  subscriptionNumber: i18n['Subscription Number'],
});

export const isTrackingInformationAvailableInRegion = (): boolean => {
  const { publicRuntimeConfig } = getConfig();
  const storeRegion = publicRuntimeConfig.STORE_REGION.toUpperCase();
  const forbiddenRegions = ['GCC', 'LATAM', 'EMEA', 'APAC'];

  return !forbiddenRegions.includes(storeRegion);
};
